module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"notMaterial":"Not Material","impactMaterial":"Impact Material","financialMaterial":"Financial Material","doubleMaterial":"Double Material","notAssessed":"Not Assessed"},"de":{"notMaterial":"Nicht Material","impactMaterial":"Einfluss Material","financialMaterial":"Finanz Material","doubleMaterial":"Doppel Material","notAssessed":"Nicht Erwartet"}}')
  delete Component.options._Ctor
}
